import {GlobalCampaign} from "@api-clients/global/campaign/schema/GlobalCampaign";

export const globalCampaignDemoData: GlobalCampaign = {
    id: "demo",
    name: "Demo Campaign",
    startDate: "2024-05-01",
    endDate: "2024-05-08"
};